// TODO: use type from exam-management-common and remove DisplayQBankStructureLevelItem from './type'
import type { DisplayQBankStructureLevelItem } from './type';

export function findLevelItemOrderById(
  items: Partial<DisplayQBankStructureLevelItem>[],
  id: string,
  courseCode: number,
) {
  let levelItemOrder = '';
  let currentId: string | null = id;

  while (currentId) {
    const levelItem = items.find(({ id: levelItemId }) => levelItemId === currentId);

    if (!levelItem) break;

    const { order, parentLevelItemId } = levelItem;

    levelItemOrder = !parentLevelItemId
      ? `${courseCode}${levelItemOrder ? `-${levelItemOrder}` : ''}`
      : `${order}${levelItemOrder ? `-${levelItemOrder}` : ''}`;

    currentId = parentLevelItemId ?? null;
  }

  return levelItemOrder;
}
